// extracted by mini-css-extract-plugin
module.exports = {"base":"LinkCard_base__A3KY8","thumbnail":"LinkCard_thumbnail___dPzx","title":"LinkCard_title__8gcPP","description":"LinkCard_description__WdCtl"};